import { computed } from '@ember/object';
export default function isNotIn(property, values) {
  return computed(property, function () {
    return !values.includes(this.get(property));
  });
}